import {BaseLayout, Layout} from '../layout';
import React, {useCallback} from 'react';
import {MenuItem} from './MenuItem';
import {MenuProps} from './types';
import {useTheme} from '../../theme';

export const Menu: React.FC<MenuProps> = ({
  selectedIndex,
  items,
  icons,
  onChange,
}) => {
  const theme = useTheme();
  // event handlers
  const handleSelectItem = useCallback(
    (index: number) => {
      onChange && onChange(index);
    },
    [onChange],
  );

  // Renders dropdown item
  const renderPopupItem = useCallback(
    (item, index: number) => {
      return (
        <Layout key={index} flex horizontal>
          <MenuItem
            title={item}
            index={index}
            icon={icons ? icons[index] : undefined}
            showSelected={selectedIndex !== undefined}
            selected={selectedIndex === index}
            onSelected={handleSelectItem}
          />
        </Layout>
      );
    },
    [handleSelectItem, icons, selectedIndex],
  );

  return (
    <BaseLayout
      vertical
      scrollable
      raised
      minWidth={140}
      borderRadius={theme.radii['8']}
      paddingVertical={theme.spacing['12']}
      zIndex={1000}
      maxHeight={theme.spacing['128'] * 2}
      backgroundColor={theme.colors['background_mono_primary']}>
      {items.map((item, index) => renderPopupItem(item, index))}
    </BaseLayout>
  );
};
